var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeploymentSdk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 252,
    viewBox: "0 0 252 252",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1001_6344)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 126,
    r: 126,
    fill: "#8E54CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.639 135.61C251.878 132.438 252 129.233 252 126C252 125.297 251.994 124.596 251.983 123.896L179 73L70 182.5L149.184 249.872C194.936 241.362 231.999 208.131 245.99 164.561L246 164.5L248 157.5L249.983 148.575C249.995 148.51 250.007 148.444 250.019 148.379L250.963 142.239C250.984 142.079 251.004 141.918 251.024 141.757L251.639 135.61Z",
    fill: "black",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.46 93.248C98.8145 106.32 90.8229 125.101 90.0808 126.87L69.4166 118.022L96.8737 90.5651L110.46 93.248ZM121.762 154.042C121.762 154.042 143.111 145.194 155.384 132.921C186.209 102.096 181.072 78.0068 179.416 72.5838C173.993 70.8713 149.904 65.7909 119.079 96.6159C106.806 108.889 97.9583 130.238 97.9583 130.238L121.762 154.042ZM158.752 141.541C145.68 153.186 126.9 161.177 125.13 161.919L133.978 182.583L161.435 155.126L158.752 141.541ZM109.375 159.75C109.375 164.488 107.434 168.769 104.352 171.852C97.6158 178.588 69.4166 182.583 69.4166 182.583C69.4166 182.583 73.4125 154.384 80.1483 147.648C83.2308 144.566 87.512 142.625 92.25 142.625C101.726 142.625 109.375 150.274 109.375 159.75ZM132.208 108.375C132.208 102.096 137.346 96.9584 143.625 96.9584C149.904 96.9584 155.042 102.096 155.042 108.375C155.042 114.654 149.904 119.792 143.625 119.792C137.346 119.792 132.208 114.654 132.208 108.375Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.46 93.248C98.8147 106.32 90.823 125.101 90.0809 126.87L69.4167 118.022L96.8738 90.5651L110.46 93.248ZM179.416 72.5838C173.993 70.8713 149.904 65.7909 119.079 96.6159C106.806 108.889 97.9584 130.238 97.9584 130.238L109.86 142.14C120.885 131.637 129.131 123.719 136.084 116.929C142.108 111.046 147.162 106.009 152.212 100.872C160.072 92.8772 167.925 84.6382 179.416 72.5838ZM69.4167 182.583C69.4167 182.583 73.4126 154.384 80.1484 147.648C83.2309 144.566 87.5122 142.625 92.2501 142.625C97.1874 142.625 101.629 144.702 104.751 148.031C86.206 167.137 84.8628 168.48 69.4167 182.583ZM132.208 108.375C132.208 102.096 137.346 96.9584 143.625 96.9584C147.039 96.9584 150.115 98.477 152.212 100.872C146.647 106.489 142.618 110.503 136.084 116.929C133.711 114.833 132.208 111.771 132.208 108.375Z",
    fill: "#F0F0FB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 108,
    r: 12,
    fill: "#8E54CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111 159C111 163.98 108.96 168.48 105.72 171.72C98.64 178.8 69 183 69 183C69 183 73.2 153.36 80.28 146.28C83.52 143.04 88.02 141 93 141C102.96 141 111 149.04 111 159Z",
    fill: "#F92E0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 183.333C69 183.333 73.2 153.693 80.28 146.613C83.52 143.373 88.02 141.333 93 141.333C98.1896 141.333 102.858 143.516 106.139 147.016C86.6471 167.098 85.2353 168.51 69 183.333Z",
    fill: "#FF5620"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 108,
    r: 12,
    fill: "#28B3E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 108C156 114.627 150.627 120 144 120C140.957 120 138.178 118.867 136.062 117C143.5 109.5 144 109 153 100.063C154.867 102.178 156 104.957 156 108Z",
    fill: "#0090FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1001_6344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 252,
    height: 252,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeploymentSdk);
export default __webpack_public_path__ + "static/media/deployment_sdk.78fd10540f5fbf80aa7815f9ffa42c34.svg";
export { ForwardRef as ReactComponent };